import React, { useState } from 'react';
import { FAQItem } from './FAQItem';

const faqs = [
  {
    q: 'How do I book a consultation?',
    a: 'Just tap any "Book on WhatsApp" button or use the chat assistant. You will be connected to Nitika directly on WhatsApp with your details pre-filled.'
  },
  {
    q: 'What information is required for a reading?',
    a: 'Typically your name, date of birth, birth place, and (where available) birth time. For some services like Name or Mobile Number Correction, we need your current name or number too.'
  },
  {
    q: 'How will I receive my consultation?',
    a: 'Depending on the service, guidance is delivered as a written report, a voice note, or a live call on WhatsApp. You will confirm the format with Nitika when booking.'
  },
  {
    q: 'How does Mobile Number Correction work?',
    a: 'Nitika analyses the numerical vibration of your current mobile number against your date of birth and personal chart, and recommends suitable number combinations for better personal, professional and financial alignment.'
  },
  {
    q: 'How does Name Correction work?',
    a: 'Your name spelling and its numerical vibration are analysed using your date of birth and, where required, Kundali details. Suitable spelling corrections or variations are then recommended.'
  },
  {
    q: 'Do I need an exact birth time?',
    a: 'A precise birth time gives the most accurate reading, but if you don\u2019t know it we can still proceed with a general chart. Just share what you have on WhatsApp.'
  },
  {
    q: 'Can I book everything through WhatsApp?',
    a: 'Yes. Every service on this site is booked, delivered and followed up entirely on WhatsApp. No forms, no accounts, no payment gateways.'
  },
  {
    q: 'How long does the consultation take?',
    a: 'Written reports are typically delivered within 24\u201348 hours. Live calls and tarot sessions are scheduled at a time that works for you.'
  }
];

export const FAQ = () => {
  const [open, setOpen] = useState(0);

  const toggle = (idx) => {
    setOpen(open === idx ? -1 : idx);
  };

  return (
    <section className="py-20 sm:py-28 bg-gradient-to-b from-[#0A0000] via-[#120606] to-[#0A0000]">
      <div className="container mx-auto px-4 max-w-3xl">
        <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] text-center mb-4 font-light">
          BEFORE YOU BEGIN
        </p>

        <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl text-center text-white mb-3 font-medium">
          Frequently Asked Questions
        </h2>
        <p className="text-center text-[#A89B8C] mb-12 text-sm">
          Clear answers about booking, delivery and privacy.
        </p>

        <div className="space-y-3" data-testid="faq-list">
          {faqs.map((item, idx) => (
            <FAQItem
              key={item.q}
              item={item}
              isOpen={open === idx}
              onToggle={() => toggle(idx)}
              testId={`faq-toggle-${idx}`}
            />
          ))}
        </div>

        <p className="text-center text-[#A89B8C] text-xs mt-10">
          Still have a question? Message on WhatsApp. Nitika personally replies.
        </p>
      </div>
    </section>
  );
};
